import { Typography, Button, Grid } from "@mui/material";

type USER_GUIDE_DESTINATION = "QuickStart" | "UserManual" | "VideoTutorial";

export default function UserGuide() {
    const handleClick = (destination: USER_GUIDE_DESTINATION) => {
        switch (destination) {
            case "QuickStart":
                window.open("https://docs.google.com/document/d/1UQdbR9AJ_LEfI-v7-bFw-8XmVdx6mAL4S18ODly5R4w/edit?usp=sharing");
                break;
            case "UserManual":
                window.open("https://docs.google.com/document/d/1gQhOsI1IVe6TEQ5e2BIRdV2g8-8OjQEK_B2wq9aurvM/edit?usp=sharing");
                break;
            case "VideoTutorial":
                window.open("https://drive.google.com/file/d/1Bm0lAlMtNju7qsJ3sbRb5P4nM4p87O-g/view?usp=sharing");
                break;
            default:
                break;
        }
    }
    return (
        <Grid container spacing={8} direction="column" alignItems={"center"}
            sx={{ padding: "36px 16px", textAlign: "center" }}>
            <Grid size={12} direction={"column"} alignItems={"center"}>
                <Typography>A detailed step by step user guide</Typography>
                <Button variant="contained" onClick={() => handleClick("UserManual")}>User Manual</Button>
            </Grid>
            <Grid size={12} direction={"column"} alignItems={"center"}>
                <Typography>Quick Start guide for the most commonly used functions</Typography>
                <Button variant="contained" onClick={() => handleClick("QuickStart")}>Quick Start</Button>
            </Grid>
            <Grid size={12} direction={"column"} alignItems={"center"}>
                <Typography>Video tutorial for the most commonly used functions</Typography>
                <Button variant="contained" onClick={() => handleClick("VideoTutorial")}>Video Tutorial</Button>
            </Grid>
        </Grid >
    )
}